// extracted by mini-css-extract-plugin
export default {"container":"CountDown_container__yzrYi","content":"CountDown_content__dx5-s","label":"CountDown_label__LnwXL"};